<template>
  <div id="operation-log" class=" ">
    <div class="active_week   dis-flex direction-column">
      <tableSearch :searchCol="searchCol">
        <i-input autocomplete="off" slot="userNo" v-model="userNo" size="small"></i-input>
        <i-input autocomplete="off" slot="ip" v-model="ip" size="small"></i-input>
        <i-input autocomplete="off" slot="device" v-model="device_id" size="small"></i-input>

        <div slot="button">
          <div class="actionBox">
            <div>
              <Button size="small" type="primary" @click="postClient">{{
                $t("views.giftInformation.query")
              }}</Button>
            </div>
          </div>
        </div>
      </tableSearch>
      <div class="tableBox">
        <tableBox :columns="titleList" :list="tablesList" :loading="false">

          <div slot="recharge_money" slot-scope="{item}">
            {{item.google_recharge_total}}/{{item.apple_recharge_total}}
          </div>
          <div slot="regist_time" slot-scope="{item}">
            {{ timestampToTime(item.register_time)}}
          </div>

          <div slot="login_time" slot-scope="{item}">
            {{ timestampToTime(item.last_login_time)}}
          </div>

          <div slot="intercept_time" slot-scope="{item}">
            {{ timestampToTime(item.intercept_time)}}
          </div>

          <div slot="last_time" slot-scope="{item}">
            {{ timestampToTime(item.last_time)}}
          </div>

          <div slot="login_ip" slot-scope="{item}">
            {{item.ip}}({{item.count_login_ip}})
          </div>

          <Page
            slot="changePage"
            :current="page"
            :total="total"
            :page-size="10"
            @on-change="changePage"
          ></Page>
        </tableBox>
      </div>


    </div>
  </div>
</template>

<script>
import tableBox from "@/components/Table/VueTable.vue";
import tableSearch from "@/components/Table/TableSearch.vue";

import until from "@/js/until.js";
import { mapGetters } from "vuex";

export default {
  name: "active_week",

  components: {
    tableBox,
    tableSearch,
  },
  data() {
    return {
      payList:[],
      keyword: "",
      time: "",

      searchCol: this.setsearchCol(),
      device_id:'',
      ip:'',
      type: 0,
      tablesList: [],
      titleList: this.getTitleList(),
      page: 1,
      total: 0,

      userNo: "",

    };
  },
  created() {
    // // 结束时间
    // let objDate = new Date();
    // objDate.setHours(23);
    // objDate.setMinutes(59);
    // objDate.setSeconds(59);
    // // 开始时间
    // let startObjTime = new Date();
    // startObjTime.setDate(objDate.getDate() - 7);
    // startObjTime.setHours(0);
    // startObjTime.setMinutes(0);
    // startObjTime.setSeconds(0);
    // this.end_time = until.timestampToTime(parseInt(objDate.getTime() / 1000));
    // this.start_time = until.timestampToTime(parseInt(startObjTime.getTime() / 1000));

    this.api_losing_recharge();
  },
  methods: {
    getTitleList() {
      return [

        {
          title: this.$i18n.tc('views.operationalPopup.text15'),
          key: 'user_no'
        },

        {
          title: this.$i18n.tc('views.violationUser.table1Text3'),
          key: 'nickname'
        },

        {
          title: this.$i18n.tc('views.user_data.country'),
          key: 'country_name'
        },
        {
          title: this.$i18n.tc('views.riskcontrolManagement.tab1text4'),
          key: 'game_level'
        },
        {
          title: '谷歌苹果充值总金额',
          key: 'google_apple_recharge_total'
        },
        {
          title: this.$i18n.tc('views.riskcontrolManagement.tab1text5'),
          key: 'balance'
        },
        {
          title: '拦截时间',
          key: 'intercept_time',
          type: 'custom'

        },
        // {
        //   title: '拦截充值金币数',
        //   key: 'recharge_gold',
        // },
        {
          title: '拦截原因',
          key: 'recharge_reason'
        },

        {
          title: this.$i18n.tc('views.user_data.registerTime'),
          key: 'regist_time',
          type: 'custom'
        },

        {
          title: this.$i18n.tc('views.user_data.lastLoginTime'),
          key: 'login_time',
          type: 'custom'
        },



        {
          title: this.$i18n.tc('views.riskcontrolManagement.tab1text7'),
          key: 'login_ip',
          type: 'custom'

        },
        {
          title: this.$i18n.tc('views.riskcontrolManagement.tab1text8'),
          key: 'device'
        },



      ]
    },



    setsearchCol() {
      return [
        {
          title: this.$i18n.tc("views.operationLogPage.userId"),
          key: "userNo",
        },
        {
          title:'IP',
          key:'ip'
        },
        {
          title:'设备',
          key: "device",
        },

      ];
    },
    // 转换时间
    timestampToTime(data) {
      return until.timestampToTime(data);
    },
    // 选择开始时间
    changeStart(data) {
      this.start_time = data;
    },
    changeEnd(data) {
      this.end_time = data;
    },

    // 查询按钮
    postClient() {
      this.page = 1;
      this.api_losing_recharge();
    },
    // 切换页码
    changePage(page) {
      this.page = page;
      this.api_losing_recharge();
    },
    // 数据请求
    api_losing_recharge() {

      let data = {
        page: 10,
        pn: this.page,
        user_no: this.userNo,
        ip: this.ip,
        device_id: this.device_id,
      };

      this.$http
        .riskControlRecordList(data, {
          method: this.api_losing_recharge,
          that: this,
        })
        .then((res) => {
          if (Number(res.status) == 200) {
            this.tablesList = res.data.list;

            this.total = Number(res.data.total);
          } else {
            this.tablesList = [];
            this.total = 0;
            this.$Message.error(res.msg);
          }
        });
    },

  },
  computed: {
    ...mapGetters(["getLocale"]),
  },
  watch: {
    getLocale() {
      this.searchCol = this.setsearchCol();
      this.titleList = this.setTitleList();
    },
  },
};
</script>
<style scoped lang="scss">
@function r($px) {
  @return $px/100 * 1rem;
}
#operation-log {
  overflow: auto;
  .tableBox {
    overflow: initial;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/riskcontrolManagement/components/log.vue